import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled, { css } from "styled-components";
import { isMobile } from "react-device-detect";
import { Navbar } from "react-bootstrap";

import { userActions } from "_store/actions";

import breakpoints from "_constants/breakpoints";

import { ReactComponent as UserSVG } from "assets/img/User.svg";
import { ReactComponent as AgentSVG } from "assets/img/Agent.svg";
import { ReactComponent as ArrowDownSVG } from "assets/img/ArrowDown.svg";
import { ReactComponent as MobileMenuSVG } from "assets/img/MobileMenu.svg";
import { ReactComponent as PhoneSVG } from "assets/img/Phone.svg";
import { ReactComponent as MailSVG } from "assets/img/Mail.svg";
import { ReactComponent as UserOutlinedSVG } from "assets/img/UserOutlined.svg";
import logo from "assets/img/trademarks-logo.png";

const AGENT_AVATAR_SIZE = 42;

const NavbarStyled = styled(Navbar)`
  min-height: 96px;
  background-color: #ffffff;
  padding: 16px 24px;
  border-bottom: 1px solid #ecedf1;
  margin-bottom: 48px;

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          flex-direction: column;
          min-height: 64px;
          margin-bottom: 0;
        `
      : css`
          @media (max-width: 700px) {
            align-items: start;
          } ;
        `}
`;
const Brand = styled.img`
  max-height: 50px;

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          max-height: 40px;

          @media (max-width: ${breakpoints.mobileM}) {
            max-height: 10vw;
          }
        `
      : css`
          @media (max-width: 700px) {
            max-height: 30px;
          }
        `}
`;
const UserInfo = styled(Navbar.Text)`
  display: flex;
  align-items: center;
  padding: 0 14px 0 0;
`;
const NavbarCollapse = styled(Navbar.Collapse)`
  display: flex;
  flex-basis: 0;
  height: 100%;
  width: 100%;
  gap: 64px;

  ${({ theme: { mobile }, hasmanager }) =>
    mobile
      ? css`
          flex: 0;
          justify-content: ${hasmanager ? "space-between" : "end"} !important;

          @media (max-width: 650px) {
            flex: auto;
            flex-grow: 0;
            gap: 24px;
          }

          @media (max-width: 320px) {
            gap: 0;
          }
        `
      : css`
          @media (max-width: 700px) {
            flex-direction: column-reverse;
            align-items: end;
            gap: 0;
            padding: 5px 0;
          } ;
        `}
`;
const AgentCard = styled.div`
  display: flex;
  flex-direction: column;
  padding: 4px 16px;
  border-right: 2px solid #ecedf1;

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          padding: 16px 0;
          border-right: none;
        `
      : css`
          @media (max-width: 700px) {
            align-items: end;
            width: 100%;
            padding: 16px 0;
            border-right: none;
            margin-top: 8px;
            border-top: 2px solid #ecedf1;
          }
        `}
`;
const AgentCardContent = styled.div`
  display: flex;
  padding-right: 8px;

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 700px) {
        border-right: 4px solid #03579c70;
      }
    `}
`;
const AgentAva = styled.div`
  margin: auto 16px auto 0;
  width: 32px;
  height: 32px;

  ${({ avaSize }) =>
    avaSize &&
    css`
      width: ${avaSize}px;
      height: ${avaSize}px;
    `}

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          @media (max-width: 400px) {
            display: none;
          } ;
        `
      : css`
          @media (max-width: 700px) {
            display: none;
          }
        `}
`;
const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
`;
const AgentRow = styled.div`
  display: flex;
  font-size: 12px;

  color: #03589c;
  font-family: "Montserrat";
  font-weight: bold;

  ${({ center }) =>
    center &&
    css`
      text-align: center;
    `}

  ${({ theme: { mobile } }) =>
    mobile
      ? css`
          font-size: 10px;

          @media (max-width: 320px) {
            font-size: 8px;
          }
        `
      : css`
          @media (max-width: 700px) {
            text-align: end;
            font-size: 10px;
            flex-direction: row-reverse;
          }
        `}
`;
const AgentRowData = styled.div`
  display: flex;
  align-items: center;
  color: #03589c;
  font-family: "Montserrat";
  font-weight: bold;
  word-break: keep-all;
  white-space: nowrap;

  & a {
    letter-spacing: 0.4px;
    text-decoration: underline;
    color: inherit;
  }
`;
const UserCard = styled.div`
  display: flex;
`;
const UserAva = styled.div`
  margin: auto 10px;
  width: 32px;
  height: 32px;
`;
const Label = styled.span`
  font-family: "Montserrat";
  font-size: 16px;
  color: #a5aaaf;

  ${({ theme: { mobile } }) =>
    !mobile &&
    css`
      @media (max-width: 700px) {
        font-size: 14px;
      }
    `}
`;
const UserName = styled(Label)`
  color: #03589c;
`;
const DropdownButton = styled.div`
  position: relative;
  cursor: pointer;
`;
const DropdownList = styled.div`
  position: absolute;
  top: 32px;
  right: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 1rem;
  color: #212529;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;

  ${({ active }) =>
    active &&
    css`
      display: block;
    `}
`;
const DropdownItemButton = styled.button`
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
`;

function Header() {
  const wrapperRef = useRef();

  const dispatch = useDispatch();
  const { userInfo: user } = useSelector(({ user }) => user);
  const { ordersList } = useSelector(({ orders }) => orders);
  const [isOpenMenu, setOpenMenu] = useState(false);

  const accountManager = ordersList.find(({ accountManager }) => accountManager)?.accountManager;

  const handleLogOut = () => dispatch(userActions.logout());

  const handleClickOutside = useCallback(
    (event) => {
      if (wrapperRef && !wrapperRef.current?.contains(event.target) && isOpenMenu) {
        setOpenMenu(false);
      }
    },
    [isOpenMenu]
  );

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [handleClickOutside]);

  return (
    <NavbarStyled expand="false" className="navbar-default">
      <Navbar.Brand>
        <Brand src={logo} />
      </Navbar.Brand>

      <NavbarCollapse className="justify-content-end show" hasmanager={accountManager ? "true" : ""}>
        {accountManager && (
          <AgentCard>
            <AgentCardContent>
              <AgentAva avaSize={AGENT_AVATAR_SIZE}>
                <AgentSVG width={AGENT_AVATAR_SIZE} height={AGENT_AVATAR_SIZE} />
              </AgentAva>
              <AgentInfo>
                <AgentRow>Your Dedicated Account Manager</AgentRow>
                <AgentRow>
                  <UserOutlinedSVG width="18px" height="18px" />
                  &nbsp;
                  <AgentRowData>{accountManager?.name || "—"}</AgentRowData>
                </AgentRow>
                <AgentRow>
                  <MailSVG width="18px" height="18px" />
                  &nbsp;
                  <AgentRowData>
                    <a href={accountManager?.email ? `mailto:${accountManager?.email}` : "#"}>
                      {accountManager?.email || "—"}
                    </a>
                  </AgentRowData>
                </AgentRow>
                <AgentRow>
                  <PhoneSVG width="18px" height="18px" />
                  &nbsp;
                  <AgentRowData>{accountManager?.phone || "—"}</AgentRowData>
                </AgentRow>
              </AgentInfo>
            </AgentCardContent>
          </AgentCard>
        )}
        <UserCard>
          {!isMobile && (
            <UserInfo>
              <Label>Welcome,</Label>
              <UserAva>
                <UserSVG width={32} height={32} />
              </UserAva>
              <UserName>{user.firstName}</UserName>
            </UserInfo>
          )}
          <DropdownButton ref={wrapperRef} onClick={() => setOpenMenu(!isOpenMenu)}>
            {isMobile ? <MobileMenuSVG /> : <ArrowDownSVG fill="#F37217" />}
            <DropdownList active={isOpenMenu} onClick={(e) => e.preventDefault()}>
              <DropdownItemButton onClick={handleLogOut}>Logout</DropdownItemButton>
            </DropdownList>
          </DropdownButton>
        </UserCard>
      </NavbarCollapse>
    </NavbarStyled>
  );
}

export default Header;
